"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isPercentage;

function isPercentage(value) {
  return typeof value === 'string' && value.indexOf('%') !== -1;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/styles/helpers/color/isPercentage.js
// module id = VAWB
// module chunks = 0